// Action Types
import {
  CHANGE_CAPTURE_COLUMNS,
  CHANGE_CAPTURE_ORDER_BY,
  CHANGE_CAPTURE_FILTERS,
  CHANGE_CAPTURE_LAWSUIT_SELECTED,
  CHANGE_CAPTURE_LAWSUITS,
  CHANGE_CAPTURE_FIELD,
  CHANGE_CAPTURE_LAWYER,
  CHANGE_CAPTURE_CARD,
  UPDATE_LAWSUIT,
  CHANGE_CAPTURE_LOADING,
  CHANGE_CAPTURE_VISIBLE,
  CHANGE_CAPTURE_EXPORT_MODEL_SELECTED,
  CHANGE_CAPTURE_EXPORT_CASES,
  CHANGE_CAPTURE_TOTAL,
  CHANGE_CAPTURE_OFFSET
} from './actions'

// Normalize
import { lawsuitNumber, uf, onlyString, oabNumber, phone, currency, toDateFormat } from '../../constants/normalize'
import { formatDate, secureData, formatCaptureDate } from '../../constants/others'
import _ from 'lodash'

const optionsLoss = [
  { value: null, label: 'Indefinida' }, { value: 'remote', label: 'Remota' }, { value: 'possible', label: 'Possível' }, { value: 'likely', label: 'Provável' }
]

export default function (state = {
  columns: [
    { label: 'Número do Processo', value: 'number', order: 'desc' },
    { label: 'UF', value: 'uf', order: 'desc' },
    { label: 'Autor', value: 'plaintiff', order: 'desc' },
    { label: 'Réu', value: 'defendant', order: 'desc' },
    { label: 'Captação Status', value: 'capturedStatus', order: 'desc' },
    { label: 'Captado em', value: 'createdAt', format: formatCaptureDate, order: 'desc' }
  ],
  orderBy: {
    value: 'createdAt',
    order: 'desc'
  },
  filters: {
    status: []
  },
  visible: {
    filters: false,
    _export: false
  },
  loading: {
    page: false,
    _export: false,
    insert: false,
    download: false
  },
  lawsuitSelected: '',
  lawsuits: [],
  cardType: 'case',
  exportModelSelected: '',
  exportCases: '',
  forms: [
    [
      { type: 'input', label: 'Número do Processo', field: 'number', value: '', editable: false, normalize: lawsuitNumber, error: false },
      { type: 'input', label: 'UF', field: 'uf', value: '', editable: false, normalize: uf, error: false },
      { type: 'input', label: 'Tribunal', field: 'lawCourt', value: '', editable: false, error: false },
      { type: 'input', label: 'Captação Status', field: 'capturedStatus', value: '', editable: false, error: false },
      { type: 'input', label: 'Distribuído em', field: 'capturedAt', value: '', editable: false, format: formatCaptureDate, error: false },
      { type: 'input', label: 'Última atualização', field: 'savedAt', value: '', editable: false, format: formatDate, error: false },
      { type: 'input', label: 'Autor', field: 'plaintiff', value: '', editable: true, error: false },
      { type: 'input', label: 'Réu', field: 'defendant', value: '', editable: true, error: false },
      { type: 'input', label: 'Juiz', field: 'judge', value: '', editable: true, error: false },
      { type: 'input', label: 'Número OAB do advogado', field: 'lawyerOabNumber', value: '', editable: true, normalize: oabNumber, error: false },
      { type: 'input', label: 'UF OAB do advogado', field: 'lawyerOabUf', value: '', editable: true, normalize: uf, error: false },
      { type: 'input', label: 'Advogado', field: 'lawyer', value: '', editable: true, normalize: onlyString, error: false },
      { type: 'input', label: 'Email', field: 'lawyerEmail', value: '', editable: true, error: false },
      { type: 'input', label: 'Telefone', field: 'lawyerPhone', value: '', editable: true, normalize: phone, error: false },
      { type: 'input', label: 'Alçada', field: 'maxValue', value: '', editable: true, normalize: currency, error: false },
      { type: 'input', label: 'Provisão', field: 'provision', value: '', editable: true, normalize: currency, error: false },
      { type: 'input', label: 'Código do Sistema', field: 'systemCode', value: '', editable: true, error: false },
      { type: 'input', label: 'Outras Obrigações', field: 'otherObligations', value: '', editable: true, error: false },
      { type: 'select', label: 'Perda', field: 'loss', value: '', editable: true, options: optionsLoss },
      { type: 'input', label: 'Comentários', field: 'notes', value: '', editable: true, error: false }
    ],
    [
      { type: 'select', label: 'Empresa', field: 'company', value: {}, editable: true, options: [] },
      { type: 'select', label: 'Escritório', field: 'lawFirm', value: {}, editable: true, options: [] },
      { type: 'select', label: 'Classificador', field: 'classifier', value: {}, editable: true, options: [] },
      { type: 'textarea', label: 'Proposta Inicial', field: 'message', value: '', editable: true }
    ]
  ],
  total: 0,
  offset: 0,
  perPage: 25
}, action) {
  switch (action.type) {
    case CHANGE_CAPTURE_COLUMNS:
      return { ...state, columns: action.payload }
    case CHANGE_CAPTURE_ORDER_BY:
      return { ...state, orderBy: action.payload }
    case CHANGE_CAPTURE_FILTERS:
      return { ...state, filters: action.payload }
    case CHANGE_CAPTURE_LAWSUIT_SELECTED:
      return { ...state, lawsuitSelected: action.payload }
    case CHANGE_CAPTURE_LAWSUITS:
      return { ...state, lawsuits: action.payload }
    case CHANGE_CAPTURE_FIELD:
      const { form, field, value, options, error } = action.payload
      return {
        ...state,
        forms: [
          ...state.forms.slice(0, form),
          state.forms[form].map(item => {
            if (item.field === field) {
              if (!_.isEmpty(value)) {
                item.value = value
              }
              if (!_.isEmpty(options)) {
                item.options = options
              }
              if (!_.isEmpty(error)) {
                item.error = error
              }
            }
            return { ...item }
          }),
          ...state.forms.slice(form + 1)
        ]
      }
    case CHANGE_CAPTURE_LAWYER:
      const { name, surname, email, phone } = action.payload

      return {
        ...state,
        forms: [
          ...state.forms.slice(0, 0),
          state.forms[0].map(item => {
            if (item.field === 'lawyer') {
              item.value = name ? `${name} ${surname}` : ''
              item.editable = name ? false : true
            }
            if (item.field === 'lawyerEmail') {
              item.value = email ? secureData(email) : ''
              item.editable = name ? false : true
            }
            if (item.field === 'lawyerPhone') {
              item.value = phone ? secureData(phone) : ''
              item.editable = name ? false : true
            }
            return { ...item }
          }),
          ...state.forms.slice(1)
        ]
      }
    case CHANGE_CAPTURE_CARD:
      return { ...state, cardType: action.payload }
    case UPDATE_LAWSUIT:
      return {
        ...state, lawsuits: state.lawsuits.map(lawsuit => {
          if (lawsuit.number === action.payload.number) {
            lawsuit = action.payload
          }
          return { ...lawsuit }
        })
      }
    case CHANGE_CAPTURE_LOADING:
      return { ...state, loading: { ...state.loading, [action.payload.type]: action.payload.loading } }
    case CHANGE_CAPTURE_VISIBLE:
      return { ...state, visible: { ...state.visible, [action.payload.type]: action.payload.visible } }
    case CHANGE_CAPTURE_EXPORT_MODEL_SELECTED:
      return { ...state, exportModelSelected: action.payload }
    case CHANGE_CAPTURE_EXPORT_CASES:
      return { ...state, exportCases: action.payload }
    case CHANGE_CAPTURE_TOTAL:
      return { ...state, total: action.payload }
    case CHANGE_CAPTURE_OFFSET:
      return { ...state, offset: action.payload }
    default:
      return state
  }
}
